<template>
  <v-data-table  v-if="!loadingError && !notInicialized && !notInicializedSalesforce" class="file-explorer-desktop"  :headers="headers" :items="content" item-key="name" hide-default-footer disable-pagination @click:row="(item) => forward(item)" >
    <!-- template v-slot:top>
      <v-btn icon v-on:click="selectAllFiles(content)">
        <v-icon color="grey">mdi-check-box-outline</v-icon>
      </v-btn>
      <v-btn icon v-on:click="$emit('download', content)">
        <v-icon color="grey">mdi-download</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.selected="{ item }">
      <v-checkbox v-model="item.selected" v-if="item.type === 'FILE'"></v-checkbox>
    </template -->
    <template v-slot:top>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined color="muted-accent" small class="mt-3 p-0" style="border: 0" v-on:click="$emit('downloadAllFiles', content)" v-if="hasFiles()">
              <v-icon dark color="muted-accent">mdi-folder-download mdi-36px</v-icon>
            </v-btn>
        </template>
        <span>Download de todos os arquivos da pasta</span>
      </v-tooltip>
    </template>
    <template v-slot:item.folder="{ item }">
      <v-list-item-avatar>
        <v-icon class="white--text" style="background-color: var(--v-muted-foreground-base);">{{ item.type === 'FOLDER' ? 'mdi-folder' : `mdi-file-${item.icon}` }}</v-icon>
      </v-list-item-avatar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn icon v-on:click="$emit('download', item, content)" v-if="item.type === 'FILE'">
        <v-icon color="muted-accent">mdi-download</v-icon>
      </v-btn>
      <SubMenu @select="(selection) => $emit(selection, item)" :options="subMenuFileItems()" v-if="item.type === 'FILE'"/>
      <SubMenu @select="(selection) => $emit(selection, item)" :options="subMenuFolderItems()" v-else/>
    </template>
    <template v-slot:no-data>
      Esta pasta está vazia
    </template>
    <template v-if="content && content.length > 0" slot="body.append">
      <tr class="muted--text controlscroll">
        <td :colspan="headers.length"></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import SubMenu from '@/components/sub-menu/index.vue';
import store from '@/common/store';

export default {
  name: 'GenericFileExplorerDesktop',
  components: { SubMenu },
  props: {
    folders: {
      type: Array,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    loadingError: {
      type: Boolean,
      required: true,
    },
    notInicialized: {
      type: Boolean,
      required: true,
    },
    notInicializedSalesforce: {
      type: Boolean,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },

  },
  data: () => ({
    selectedFiles: [],
    headers: [
      {
        text: 'Nome',
        value: 'folder',
        name: 'folder',
        sortable: false,
        class: 'pa-2 folder-column',
      },
      {
        text: '',
        value: 'name',
        name: 'name',
        sortable: false,
        class: 'pa-2',
      },
      {
        text: 'Criado',
        value: 'created',
        sortable: false,
      },
      {
        text: 'Modificado',
        value: 'modified',
        sortable: false,
      },
      {
        text: 'Tamanho',
        value: 'size',
        sortable: false,
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'right',
      },
    ],
  }),
  computed: {
    content() {
      return [...this.folders, ...this.configuredFiles];
    },
    configuredFiles() {
      return this.files.map((file) => ({ ...file, icon: this.getFileIcon(file.name) }));
    },
  },
  methods: {
    getFileIcon(fileName) {
      const fileExtension = fileName.split('.')[1];
      let iconName = 'file';

      const types = {
        word: ['doc', 'dot', 'webk', 'docx', 'docm', 'dotx', 'dotm', 'docb'],
        excel: ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xla', 'xlam', 'xll', 'xlw'],
        powerpoint: ['ppt', 'pot', 'pps', 'pptx', 'pptm', 'potx', 'potm', 'ppam', 'ppsx', 'ppsm', 'sldx', 'sldm'],
        pdf: ['pdf'],
        csv: ['csv'],
        alt: ['txt'],
        image: ['png', 'jpg', 'jpeg', 'svg'],
      };

      Object.keys(types).forEach((typeName) => {
        if (types[typeName].includes(fileExtension)) {
          iconName = typeName;
        }
      });
      return iconName;
    },
    information(item) {
      this.$emit('information', item);
    },
    manualNotification(item) {
      this.$emit('manualNotification', item);
    },
    forward(item) {
      if (item.type !== 'FOLDER') {
        return;
      }
      const itemAsJSON = JSON.stringify(item);
      const itemIndex = this.content.findIndex((itemToCheck) => JSON.stringify(itemToCheck) === itemAsJSON);
      this.$emit('forward', itemIndex);
    },
    deleteItem(file) {
      this.$emit('deleteItem', file);
    },
    subMenuFileItems() {
      const listActions = [];
      if (this.allowRename) { listActions.push({ title: 'Renomear', value: 'rename' }); }
      if (this.allowDelete) { listActions.push({ title: 'Excluir', value: 'delete' }); }
      listActions.push({ title: 'Informações', value: 'informations' });
      if (!store.getHasMenu() || store.getHasNotificationConfigAuthority()) {
        listActions.push({ title: 'Emitir Notificação', value: 'manualNotification' });
      }
      return listActions;
    },

    subMenuFolderItems() {
      const listActions = [];
      if (this.allowDelete) {
        listActions.push({ title: 'Excluir', value: 'delete' });
      }

      listActions.push({ title: 'Informações', value: 'informations' });

      if (!store.getHasMenu() || store.getHasNotificationConfigAuthority()) {
        listActions.push({ title: 'Emitir Notificação', value: 'manualNotification' });
      }
      return listActions;
    },
    hasFiles() {
      return this.configuredFiles.length > 1;
    },
    /* selectAllFiles(files) {
      files.map((f) => {
        // eslint-disable-next-line no-param-reassign
        f.selected = true;
        return f;
      });
    }, */
  },
};
</script>

<style lang="scss">

.file-explorer-desktop {
  .v-data-table__wrapper > table > tbody > tr {
    cursor: pointer;
  }
}

.text-start {
  padding: 0px !important;
}

.v-avatar {
  margin-left: 7px !important;
}

.folder-column {
  width: 50px;
}

.controlscroll:hover {
  color: var(--v-brightGray-base) !important;
}

</style>
